function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1C0 0.447715 0.447715 0 1 0H7C8.32608 0 9.59785 0.526784 10.5355 1.46447C11.4732 2.40215 12 3.67392 12 5V19C12 19.5523 11.5523 20 11 20C10.4477 20 10 19.5523 10 19C10 18.4696 9.78929 17.9609 9.41421 17.5858C9.03914 17.2107 8.53043 17 8 17H1C0.447715 17 0 16.5523 0 16V1ZM10 15.5359V5C10 4.20435 9.68393 3.44129 9.12132 2.87868C8.55871 2.31607 7.79565 2 7 2H2V15H8C8.70823 15 9.39709 15.1878 10 15.5359Z",
  fill: "#ABACAC"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4645 1.46447C12.4021 0.526784 13.6739 0 15 0H21C21.5523 0 22 0.447715 22 1V16C22 16.5523 21.5523 17 21 17H14C13.4696 17 12.9609 17.2107 12.5858 17.5858C12.2107 17.9609 12 18.4696 12 19C12 19.5523 11.5523 20 11 20C10.4477 20 10 19.5523 10 19V5C10 3.67392 10.5268 2.40215 11.4645 1.46447ZM12 15.5359C12.6029 15.1878 13.2918 15 14 15H20V2H15C14.2044 2 13.4413 2.31607 12.8787 2.87868C12.3161 3.44129 12 4.20435 12 5V15.5359Z",
  fill: "#ABACAC"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/training.49820deb.svg";
export { SvgComponent as ReactComponent };